import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar2Colors = {
  background?: string;
  skin?: string;
  hair?: string;
  accessories?: string;
};

export const Avatar2 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar2Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
    accessories: colors.accessories ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar2">
        <G id="Group">
          <Path
            id="background"
            d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
            fill={c.background}
          />
          <Path
            id="skin"
            d="M182.765 222.187c11.134-.136 25.565-15.546 39.916-54.267 2.007-12.973.056-12.551.056-27.906 6.896-44.526-13.205-105.96-53.319-105.96-72.425 0-69.502 45.864-69.502 92.374 0 .916.016 1.848.048 2.771-1.33-.071-2.803.144-4.468.685-5.423 1.776-7.064 10.258-3.663 18.947 3.153 8.059 9.525 13.451 14.757 12.782a117.436 117.436 0 0 0 8.107 17.552c-.271 15.857-.223 41.365-2.039 48.23-2.986 11.269-18.834 16.159-18.834 16.159s62.007 60.2 92.573 57.556c18.532-.35 15.745-47.203 15.745-47.203s-18.899-4.85-19.982-12.885c-.334-2.453-.334-10.353-1.131-20.42.741.016 1.012 1.601 1.736 1.593v-.008Z"
            fill={c.skin}
          />
          <Path
            id="Vector"
            d="M137.171 116.393s8.601-1.967 18.118-1.791c11.182.199 22.3 9.278 24.115 5.853 2.485-4.691-1.521-9.827-21.924-11.858-9.135-.908-12.09 2.413-20.301 7.796h-.008Z"
            fill="#000"
          />
          <Path
            id="Vector_2"
            d="M222.227 112.388c-18.564-2.732-22.801 7.446-21.757 9.389.645 1.203 2.253 1.346 3.719-.008 5.336-2.11 8.235-2.11 17.879-2.269.247-1.378.175-5.957.151-7.112h.008Z"
            fill="#000"
          />
          <Path
            id="Vector_3"
            d="M176.1 164.352c-.685 3.528 4.133 6.356 15.498 5.758 9.357-.493 8.935-6.49 7.104-7.43-1.832-.94-2.159 2.445-8.251 2.724-5.973.278-13.658-4.588-14.351-1.06v.008Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <Path
            id="Vector_4"
            d="M156.755 125.823c-11.261 1.29-14.144 3.871-18.19 2.214 0 0 1.354 6.921 4.866 6.921 2.166 0 4.818-1.33 7.94-2.373 0 .095-.024.199-.024.294 0 3.552 3.146 6.435 7.032 6.435 3.68 0 6.698-2.588 7.001-5.885 4.475 2.007 8.489 4.762 8.489 4.762s-5.853-13.65-17.114-12.36v-.008Z"
            fill="#000"
          />
          <Path
            id="Vector_5"
            d="M212.057 127.894c-6.865.907-11.627 2.269-13.061 10.09 0 0 .988-.605 2.533-1.37.9 2.381 3.36 4.094 6.267 4.094 3.664 0 6.634-2.716 6.634-6.069 0-.271-.024-.542-.063-.804.079.024.167.039.246.063 4.349 1.322 6.595 3.066 7.495 3.919.079-2.35.143-4.723.175-7.104-1.665-1.29-5.296-3.481-10.218-2.827l-.008.008Z"
            fill="#000"
          />
          <Path
            id="Vector_6"
            d="M117.875 178.831c0 .159 0 .319-.008.478 2.222 9.222 8.696 25.572 27.619 40.998 13.706 11.166 27.101 14.567 35.941 15.451-.103-4.158.104-9.677.398-15.156-14.032-.247-30.119-4.707-44.924-17.775-7.439-6.571-13.858-14.869-19.026-23.98v-.016Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <Path
            id="Vector_7"
            d="M202.827 254.959a69.097 69.097 0 0 0-1.593-.278c.478.183.749.278.749.278s2.707 41.931-15.291 42.265c-29.666 2.565-89.15-53.669-89.15-53.677l-50.077 18.548c27.205 25.763 63.943 41.564 104.368 41.564 36.714 0 70.378-13.029 96.627-34.715-14.598-5.328-33.313-11.659-45.641-13.993l.008.008Z"
            fill="#000"
          />
          <Path
            id="Vector_8"
            d="M206.729 180.647c-7.924-3.759-15.482-1.004-17.306-1.004-1.823 0-18.365-3.703-23.39.51-.725.613 6.523 19.783 23.39 19.791 14.495.015 18.198-18.875 17.306-19.297Zm-16.605 12.017c-13.236.136-22.347-11.667-22.299-11.731.064-.079 10.361 2.987 22.076 2.724 8.116-.183 16.079-2.516 16.008-2.469-.574.391-7.192 11.389-15.793 11.468l.008.008Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <Path
            id="hair"
            d="m54.004 240.09 1.202 19.145 27.213-9.532 16.7-6.977s32.613-13.881 30.511-28.909c-.781-5.599-6.778-9.995-6.778-9.995s3.21-4.069 3.21-9.995c0-5.925-16.852-32.031-16.852-32.031s-16.047-3.281-16.047-20.34 19.631-10.616 21.104-2.134c.311 1.808 5.973 0 5.973 0V121.69h-5.973l4.078-2.676a5.435 5.435 0 0 0 2.333-3.536l.414-2.182c.327-1.713-1.178-3.202-2.811-2.772l-15.546 1.41 1.466-5.607 26.018-2.556c1.187-.223 2.119-1.171 2.357-2.398l.884-4.603c.423-2.206-1.529-4.117-3.623-3.536l-19.56 1.633.526-2.883 25.365-2.851c2.389-.478 3.855-3.003 3.138-5.416-.653-2.206-2.883-3.464-5.017-2.835l-21.009.972 1.298-4.237s29.801 1.386 35.456-3.839c5.654-5.224-10.306-10.098-10.306-10.098s17.322 3.846 23.016 3.424c5.694-.422 19.13-4.65 19.13-4.65l-10.202-15.73 15.426 15.236s16.398 1.975 21.391 8.139c4.994 6.172 13.38 34.516 13.738 42.289.358 7.772-.311 15.776.048 17.632.358 1.848-1.497 9.963-.159 17.25 4.993 27.221-18.055 57.356-22.363 63.035-9.35 12.328-18.724 10.289-18.724 10.289l.725 22.068s6.905 8.976 21.073 12.305c14.176 3.329 23.446 6.339 23.446 6.339s6.833-8.259 6.474-17.879c-.358-9.62-5.351-13.324-5.351-13.324s10.695-5.925 10.337-14.438c-.358-8.514-7.128-13.324-7.128-13.324s11.054-3.703 11.413-12.958c.358-9.254-8.203-15.545-8.203-15.545s6.793-4.07 8.21-14.805c1.418-10.736-3.217-17.402-3.217-17.402s4.125-7.406 3.488-14.805c-.637-7.406-5.63-13.323-5.63-13.323s4.276-9.255 3.209-16.287c-1.067-7.032-6.777-12.583-6.777-12.583s2.851-9.62-.359-15.546c-3.209-5.925-7.844-6.291-7.844-6.291s.358-9.62-4.277-12.217c-4.635-2.596-9.628-1.107-9.628-1.107s-11.174-12.583-24.72-16.66c-13.547-4.07-26.027-1.848-26.027-1.848s-4.993-7.407-17.473-5.925c-12.479 1.48-18.54 8.147-18.54 8.147s-5.702-5.551-13.905 1.107c-8.203 6.666-9.987 14.064-9.987 14.064s-7.486-3.703-11.412 1.848c-3.918 5.55-3.918 12.217-3.918 12.217s-8.203.366-11.413 8.147c-3.21 7.773 0 16.286 0 16.286s-8.912 1.481-12.48 15.546c-3.567 14.064 0 21.096 0 21.096s-8.911 4.444-8.911 14.065c0 9.62 3.21 18.882 3.21 18.882s-8.203 1.482-8.912 10.361c-.717 8.888 3.21 17.402 3.21 17.402s-9.63 3.329-10.338 14.805c-.717 11.476 3.568 18.142 3.568 18.142s-7.486-.741-7.486 7.406v15.18s-2.159 2.238-4.038 4.595a153.012 153.012 0 0 0 16.04 17.783s1.935-3.544 4.412-9.939c2.476-6.395 2.118-12.073 2.118-12.073l.016-.016Z"
            fill={c.hair}
          />
          <Path
            id="accessories"
            d="M86.768 181.579c0 16.565 9.341 29.992 20.873 29.992 11.524 0 20.874-13.427 20.874-29.992s-9.342-29.993-20.874-29.993c-11.524 0-20.873 13.428-20.873 29.993Zm9.493 1.107c0-8.569 4.834-15.514 10.799-15.514s10.799 6.945 10.799 15.514c0 8.569-4.834 15.514-10.799 15.514s-10.8-6.945-10.8-15.514Z"
            fill={c.accessories}
          />
          <Path
            id="accessories_2"
            d="M222.617 162.449c-.135 1.537-.358 3.305-.685 5.456a299.22 299.22 0 0 1-2.978 7.685c1.847 2.357 2.978 5.463 2.978 8.88 0 7.366-5.224 13.339-11.675 13.339-.621 0-1.218-.071-1.816-.175-2.238 3.894-4.452 7.247-6.618 10.09a20.086 20.086 0 0 0 7.805 1.585c12.464 0 22.57-11.54 22.57-25.779 0-8.713-3.783-16.406-9.573-21.073l-.008-.008Z"
            fill={c.accessories}
          />
        </G>
      </G>
    </Svg>
  );
};
